<template>
    <div>
        <v-dialog v-model="dialog" dark fullscreen persistent hide-overlay transition="dialog-bottom-transition">
            <template v-slot:activator="{ on }">
                <v-btn
                        color="secondary"
                        dark
                        @click="dialog = !dialog"
                        class="small-btns"
                >
                    {{$t('Replace image')}}
                </v-btn>
            </template>
            <v-card :loading="loading">
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="close()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{$t('Wybierz plik')}}</v-toolbar-title>
                    <v-toolbar-items v-if="selected_cat" style="display: flex; align-items: center">
                        <v-btn @click="changeCatalog()" icon class="ml-3"><v-icon>mdi-arrow-left</v-icon></v-btn>
                        <span>{{$t('Katalog')}}: {{selected_cat.name}}</span>
                    </v-toolbar-items>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" v-if="multiple" @click="emit()" dark>{{$t('Save')}}</v-btn>
                </v-toolbar>
                <div class="row mx-0" v-if="!loading">
                    <div class="col-md-8">
                        <div class="row">
                            <div class="col-md-3" v-for="m in filteredMedia">
                                <v-card>
                                    <v-img
                                            :src="(m.type == 'file')? getImage(m.path)+ '?rnd=' + cacheKey : getImage('default/folder.svg')"
                                            class="white--text align-end"
                                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                                            height="200px"
                                            v-if="!loading"
                                    >
                                    </v-img>
                                    <v-card-title  :class="{'d-flex': 'true', 'flex-column' : 'true', 'pt-0': m.type == 'file' }">
                                        <div v-if="m.type == 'file'" style="font-size: 0.65rem">{{ m.path.split('/')[m.path.split('/').length-1] }}</div>
                                        <div class="d-flex flex-row">
                                            <v-btn :loading="uploading" :outlined="(selected_multiple.find(x => x == m.path) != null)? true : false" class="ma-1" color="primary" @click="select(m)"><span v-if="m.type == 'file'"><span v-if="selected_multiple.find(x => x == m.path) == null">{{$t('Select file')}}</span><span v-else>{{$t('Unselect file')}}</span></span><span v-else>{{$t('Catalog')}}</span></v-btn>
                                            <div>
                                                <v-btn v-if="selected_cat == null || selected_cat.name !=='photos'" :loading="uploading" class="ma-1" color="red" fab small @click="remove(m)"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
                                                <!--<v-btn :loading="uploading" class="ma-1" color="primary" v-if="m.type == 'file' && (m.extension == 'png' || m.extension == 'jpg' || m.extension == 'jpeg')" fab small @click="$root.$eventBus.$emit('imageEdit', {src: m.path})"><v-icon>mdi-pencil</v-icon></v-btn>-->
                                            </div>
                                        </div>
                                    </v-card-title>
                                    <v-card-text>
                                        <span v-if="m.type == 'directory'" class="font-weight-bold white--text" style="font-size: 18px">{{m.name}}</span>
                                    </v-card-text>
                                </v-card>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4" v-if="selected_cat == null ||  selected_cat.name !=='photos'">
                        <input type="file" id="file_input" @change="uploadFile()" style="display: none" ref="file_input">
                        <v-btn @drop.stop.prevent="drop" @dragover.stop.prevent="dragging = true" @dragleave.stop.prevent="dragging=false" :class="{'dragging': dragging}" @click="$refs.file_input.click()" style="border: 1px dashed white !important;" :loading="uploading" tile outlined min-height="120px" class="w-100">
                            <div class="pa-4 px-10" style="border-radius: 8px">
                                {{$t('Drop files to upload')}}
                                <div class="w-100 font-weight-light" style="font-size: 0.8rem">
                                    {{$t('Or click in upload dropzone')}}
                                </div>
                            </div>
                        </v-btn>
                        <div class="my-2">
                            <v-btn v-if="selected_cat == null" color="primary" @click="(new_cat == null)? new_cat = {} : new_cat = null"><span v-if="new_cat == null">{{$t('Utworz katalog')}}</span><span v-else>{{$t('Cancel creating new folder')}}</span></v-btn>
                        </div>
                        <div v-if="new_cat != null">
                            <my-form ref="folder_form">
                                <v-text-field :rules="[validationRules.required]" label="Enter folder name" v-model="new_cat.name"></v-text-field>
                                <v-btn @click="($refs.folder_form.my_validate())? createCat() : null" color="primary">{{$t('Zapisz')}}</v-btn>
                            </my-form>
                        </div>
                    </div>
                </div>
            </v-card>
        </v-dialog>
        <div v-if="show_elements" class="my-2 mt-5 d-flex">
            <v-btn v-if="tmp_value && typeof tmp_value == 'string'" @click="select({path: null, type: 'file'})" class="ml-2" fab x-small color="red"><v-icon class="white--text">mdi-trash-can-outline</v-icon></v-btn>
            <v-img contain max-width="300px" v-if="tmp_value && typeof tmp_value == 'string' && !favicon" :src="resolveImage()" max-height="200">
                <!--<v-btn fab x-small @click="dialog = true" color="primary"><v-icon>mdi-pencil</v-icon></v-btn>-->
            </v-img>

            <v-img contain max-width="88" v-if="tmp_value && typeof tmp_value == 'string' && favicon" :src="resolveImage()" max-height="88">
                <!--<v-btn fab x-small @click="dialog = true" color="primary"><v-icon>mdi-pencil</v-icon></v-btn>-->
            </v-img>

            <v-img contain class="ma-2" max-width="300px" v-if="tmp_value && typeof tmp_value == 'object'" v-for="(element,index) in tmp_value" :src="$root.getSrc(element)" max-height="200">
                <!--<v-btn fab x-small @click="dialog = true" color="primary"><v-icon>mdi-pencil</v-icon></v-btn>-->
                <v-btn @click="deleteFromArray(index)" class="ml-2" fab x-small color="red"><v-icon class="white--text">mdi-trash-can-outline</v-icon></v-btn>
            </v-img>
        </div>
    </div>
</template>
<script>
    import {getUserUploads, removeFile} from "../api/upload";
    import {upload} from "../api/upload";
    import {createCat} from "../api/upload";

    export default {
        props:{
            value: [String, Number, Array],
            show_elements: {
                default: false,
                type: Boolean
            },
            multiple:{
                type: Boolean,
                default: false
            },
            favicon: {
                default: false,
                type: Boolean
            }
        },

        data(){
            return{
                selected_multiple: [],
                selected_cat: null,
                new_cat: null,
                cacheKey: null,
                dialog: false,
                media: null,
                uploading: false,
                loading: false,
                tmp_value: null,
                dragging: false
            }
        },
        watch:{
            value: function(){
              this.tmp_value = this.value;
            },
            dialog: function () {
                if(this.dialog == true){
                    this.getMedia();
                }
            }
        },
        computed:{
            filteredMedia(){
                if(this.selected_cat == null){
                    return this.media;
                }else{
                    return this.selected_cat.childrens;
                }
            }
        },
        mounted() {
            this.tmp_value = this.value;
        },
        methods:{
            resolveImage(){
                if(typeof this.tmp_value == 'object'){
                    return this.getSrc(this.tmp_value[0])
                }else{
                    return this.getSrc(this.tmp_value);
                }
            },
            createCat(){
                createCat(this.new_cat).then(response => {
                    this.new_cat = null;
                    this.getMedia();
                }).catch(e => {
                    if(e.response.data && e.response.data.errors){
                        this.$store.commit('app/ADD_MESSAGE', {text: e.response.data.errors.name[0], type: 'error'});
                    }
                })
            },
            deleteFromArray(index){
                this.selected_multiple.splice(index, 1);
                this.emit();
            },
            remove(media){
                var title = 'Deleting';
                (media.type == 'file')? title = title+' file' : title = title+' catalog';
                this.$confirm(title, this.$t('Remember, deleting this item may result in missing items on the page'), {accept: {text: 'Yes', color:'red'}, cancel: {text: 'No'}}).then(() => {
                    this.uploading = true;
                    removeFile({path: media.path}).then(response => {
                        this.uploading = false;
                        this.getMedia(true);
                    }).catch(e => {
                        if(e.response.data.message){
                            this.$store.commit('app/ADD_MESSAGE', {text: e.response.data.message, type:'error'});
                        }
                        this.uploading = false;
                        this.getMedia(true);
                    })

                })
            },
            uploadFile(event, files = null){
                var formData = new FormData();
                formData.append('files[]', (!files)? this.$refs.file_input.files[0] : files[0]);
                if(this.selected_cat){
                    if(this.selected_cat.childOf){
                        formData.append('path', this.selected_cat.childOf+'/'+this.selected_cat.name);
                    } else {
                        formData.append('path', this.selected_cat.name);
                    }
                    var folder = true;
                }else{
                    formData.append('path', '');
                    var folder = false;
                }
                this.uploading = true;
                upload(formData, 'media').then(response => {
                    this.uploading = false;
                    this.getMedia(true);
                }).catch(e => {
                    this.uploading = false;
                })
            },
            getImage(src){
                return this.$root.base_url+'/storage/'+src;
            },
            emit(){
              this.$emit('input', this.selected_multiple);
              this.close();
            },
            select(media){
                if(media.type == 'file'){
                    if(this.multiple){
                        var index = 0;
                        if((index = this.selected_multiple.findIndex(x => x == media.path)) == -1) this.selected_multiple.push(media.path);
                        else this.selected_multiple.splice(index, 1);
                    }else{
                        this.$emit('input', media.path);
                        this.close();
                    }
                }else{
                    this.selected_cat = media;
                }
            },
            close(){
                this.dialog = false;
            },
            drop(event){
                this.dragging = false;
                var event = event.originalEvent || event;
                var files = event.target.files || event.dataTransfer.files;
                var formData = new FormData();
                var length = files.length;
                this.uploadFile(event, files)
            },
            getMedia(deleted = false){
                getUserUploads().then(response => {
                    this.media = response;
                    if(typeof this.media == 'object') this.media = Object.values(this.media);
                    if(this.selected_cat){
                        this.media.forEach(item => {
                            if(item.name == this.selected_cat.name){
                                this.selected_cat = item;
                            }
                        })
                    } else {
                        if(!this.$route.path.includes('/websites/create') && !deleted){
                            for(let i=0;i<this.media.length;i++){
                                if(this.$store.getters.activeWebsite.name === this.media[i].name && this.media[i].type ==='directory'){
                                    this.selected_cat = this.media[i];
                                    break;
                                }
                            }
                        }
                    }
                }).catch(e => {
                    this.$store.commit('app/ADD_ERROR', {text: this.$t('Cant download files')});
                })
            },
            displayDialog(){
                this.dialog = true;
            },
            changeCatalog(){
                if(!this.selected_cat.childOf){
                    this.selected_cat = null;
                } else {
                    for(let i=0;i<this.media.length;i++){
                        if(this.selected_cat.childOf === this.media[i].name && this.media[i].type ==='directory'){
                            this.selected_cat = this.media[i];
                            break;
                        }
                    }
                }
            }

        }
    }
</script>
<style lang="scss">
    .dragging{
        background-color: var(--violet_light-color) !important;
    }
</style>
